import { useState } from 'react';
import { Line } from '../types';

interface LineManagerProps {
  lines: Line[];
  onLinesUpdate: (lines: Line[]) => void;
  selectedHeaderToOrg?: string;
}

export const useLineManager = ({ lines, onLinesUpdate, selectedHeaderToOrg }: LineManagerProps) => {
  const [newRowIds, setNewRowIds] = useState<Set<string>>(new Set());



  const updateLine = (lineId: string, field: string, value: string) => {
    console.log('updateLine called:', { lineId, field, value });
    
    const fieldMap: Record<string, keyof Line> = {
      'Validated Serial Number': 'validatedSerialNumber',
      'Validated Asset Number': 'validatedAssetNumber',
      'To Subinventory': 'toSubinventory',
      'To Locator': 'toLocator',
      'Validated Serial Item': 'validatedSerialItem',
      'Repair Eligibility': 'repairEligibility',
      'Tracking Number': 'trackingNumber'
    };

    const updatedLines = lines.map(line => {
      if (line.id === lineId) {
        const updatedLine = { ...line, [fieldMap[field]]: value };
        console.log('Updating line:', line.id, 'field:', field, 'new value:', value);
        return updatedLine;
      }
      return line;
    });
    
    console.log('Updated lines:', updatedLines);
    onLinesUpdate(updatedLines);
  };

  const cancelChanges = () => {
    // Remove new rows and revert to original state
    onLinesUpdate([]);
    setNewRowIds(new Set());
  };

  const clearNewRowIds = () => {
    setNewRowIds(new Set());
  };

  return {
    updateLine,
    cancelChanges,
    clearNewRowIds,
    newRowIds
  };
};